import ReactDOMServer from 'react-dom/server';
/* global google */

import html2canvas from 'html2canvas';


import * as Fenomenes from './../../../constants/icons/fenomenes/Fenomenes'
import * as Thiefts from './../../../constants/icons/fenomenes/hurtos/Hurtos';

var heatmapGis;
var markersGis = [];
var PopupGis, popupOldGis;
var dataPoli = [[]];
var polygon = [];
var iPoly = 0;
var activo = 0;
var distance;
var stateHeat;
var dataMap = [];
var dataMapCircle = [];
var circle1 = null;
var mapGis = null;
var checComunas = [];

var data = [];
data.push({ lng: -75.3697457, lat: 6.158583 });
data.push({ lng: -75.369, lat: 6.158 });
var srcComunas = 'http://administrativo.eaconsultores.com.co/Content/files/Corregimiento-Comunas3.kml';
var srcBarrios = 'http://administrativo.eaconsultores.com.co/Content/files/test2-9.kml';

var polyBarrios;
var polyComunas;

var docBarrios;
var docComunas;
var streets;


var center = { lng: -75.3697457, lat: 6.111265 };


//pruba.appendChild(divContent);
const initMap = () => {


    HttpServiceCom(srcComunas);
    HttpServiceBar(srcBarrios);

    definePopupClass();

    let divMap = document.createElement('div');
    divMap.id = 'mapGis';
    try {        
        document.getElementById('gis').appendChild(divMap);
    } catch (error) {
        return;
    }




    let divContent = document.createElement('div');
    divContent.id = 'content';


    mapGis = new google.maps.Map(document.getElementById('mapGis'), {
        center,
        zoom: 12,
        disableDefaultUI: true,
        styles: styleClean
    });

    document.getElementById('mapGis').appendChild(divContent);

    mapGis.addListener('click', function (event) {
        click(event);
    });
    let divCalles = document.createElement('div');
    divCalles.classList.add('boton-mapa');
    divCalles.classList.add('bottom-left');
    divCalles.classList.add('boton-atras');
    divCalles.innerHTML = '<i class="material-icons icon-back" title="Vías">near_me</i>';
    divCalles.addEventListener("click", function () {
        BotonStreet();
    });

    streets = false;

    document.getElementById('mapGis').appendChild(divCalles);


    //createMarkers(location);

    // let html = '<img class="image-heigth" src="http://administrativo.eaconsultores.com.co/Content/files/images/logo-siscoa.svg">';
    // html = html + '<img class="image-heigth" src="http://administrativo.eaconsultores.com.co/Content/files/images/rionegro-80px.png">';
    // let divOtro = document.createElement('div');
    // divOtro.innerHTML = html;
    // document.body.appendChild(divOtro);

}

export const startMap = () => {
    setTimeout(() => {
        initMap();
    }, 2000);
}

function BotonStreet() {
    if (streets) {
        mapGis.setOptions({
            styles: styleClean
        });
        streets = false;
    } else {
        mapGis.setOptions({
            styles: styleRoad
        });
        streets = true;
    }
}





// function GetCordsFromPlacemark(place) {
//     var coords = place.getElementsByTagName('coordinates');
//     var coordsVec = coords[0].innerHTML.split(" ");
//     var resp = [];
//     for (let i = 0; i < coordsVec.length; i++) {
//         let vec = coordsVec[i].split(',');
//         resp.push({ lng: vec[0], lat: vec[1] });
//     }
//     return resp;
// }


function createMarkers(vector) {
    vector.map((val, i) => {
        let marker = new google.maps.Marker({
            position: val,
            map: mapGis,
            icon: getIconPath(val.fen)
        });
        marker.addListener('click', function () {
            try { popupOldGis.setMap(null) } catch (e) { }
            var popupgis = new PopupGis(
                new google.maps.LatLng(val),
                document.getElementById('content'),
                val
            );
            popupgis.setMap(mapGis);
            popupOldGis = popupgis;
        });
        markersGis.push(marker);
        return null;
    });
    stateHeat = false;
    createHeat(vector);
}

function createHeat(vector) {
    let data = [];

    vector.map((value, i) => {
        data.push(new google.maps.LatLng(value));
        return null;
    });
    let intensity = (vector.length * 0.25);
    heatmapGis = new google.maps.visualization.HeatmapLayer({
        data,
        maxIntensity: intensity
    });
}

export const SetActivo = (value) => { activo = value; }
export const SetDistance = (value) => { distance = value; }

function GetPinFromData(data) {
    let fenos = [];
    let html = '';
    for (let i = 0; i < data.length; i++) {
        if (!fenos.includes(data[i].fen)) {
            fenos.push(data[i].fen);
            // let icon = 
            html = html + '<div class="content-legend"><div class="icon-heigth">' + getIcon(data[i].fen).replace(/green/g, '#003951') + '</div><p style="">' + data[i].fen + '</p></div>';
        }
    }
    return html;
}

export const CreateModal = (image) => {
    let divModalContenedor = document.createElement('div');
    divModalContenedor.classList.add('modal-container');
    divModalContenedor.classList.add('position');
    let left = (window.innerWidth - 1100) / 2;
    divModalContenedor.style.left = left + 'px';


    let height = window.innerHeight;
    let hDiv = 0;
    if (height > 730) {
        hDiv = 500;
    } else {
        hDiv = height - 230;
    }

    let html = '<hr/><h2 style="text-align: center">Sistema de Informacion del Oriente Antioqueño</h2>' +
        '<div class="container-fluid">' +
        '<div class="row">' +
        '<div class="col-70 clip" style="background-position:-200px -100px !important; height:' + hDiv + 'px; background: url(' + image + ')"></div>' +
        '<div class="col-30" style="height:' + hDiv + 'px">' +
        '<div>' +
        '<img alt="siscoa-80px.png"  class="image-heigth mr-l20"' +
        'src="data:image/png;base64,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" />' +
        '<br />' +
        '<img alt="rionegro-80px.png" class="image-heigth mr-l85"' +
        'src="data:image/png;base64,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" />' +
        '</div>' +
        '<br />' +
        '<br />' +
        '<br />' +
        '<br />' +
        '<br />' +
        '<br />' +
        '<br />' +
        '<br />' +
        '<br />' +
        '<h3 style="text-align:center;margin-bottom:5px; color: #003951">Leyenda</h3>' +
        GetPinFromData(location) +
        '</div>' +
        '</div>' +
        '</div>' +
        '<hr style="margin-top:20px"/>';

    //Funciones
    let cerrar = 'document.body.removeChild(document.getElementById(\'modal\')); ';
    let descargar =
        // 'console.log(\'tal\');' +
        'html2canvas(document.getElementById(\'contenido-descarga\')).then(function(canvas) {' +
        'canvas.toBlob(function(blob) {' +
        'window.saveAs(blob, \'miMapa.png\');' +
        cerrar +
        '});' +
        '});';

    // let estilos = 'mapGis.setOptions({styles: [{' +
    //     'featureType: \'administrative.locality\',' +
    //     'elementType: \'labels\',' +
    //     'stylers: [{ visibility: \'on\' }]}]});'

    let divBody = document.createElement('div');
    divBody.id = 'contenido-descarga';
    divBody.innerHTML = html;

    // let title = document.createElement('h2');
    let footer = document.createElement('div');
    footer.innerHTML =
        '<button type="submit" class="button fl-r" onclick="{' + descargar + '}">Descargar</button>' +
        '<button class="button fl-r" onclick="{' + cerrar + '}">Cerrar</button>';

    divModalContenedor.appendChild(divBody);
    divModalContenedor.appendChild(footer);
    let divModalMedio = document.createElement('div');
    divModalMedio.classList.add('modal-medio');
    let divModal = document.createElement('div');
    divModal.id = 'modal';
    divModal.classList.add('modal-fondo');
    divModal.appendChild(divModalMedio);
    divModal.appendChild(divModalContenedor);

    document.body.appendChild(divModal);
}

export const Cerrar = () => {
    document.body.removeChild(document.getElementById('modal'));
}


export const saveMapToDataUrl = () => {

    // var element = document.getElementById('mapGis');


    html2canvas(document.querySelector("#mapGis"), {
        useCORS: true
    }).then(canvas => {
        var dataUrl = canvas.toDataURL("image/png");

        // let img = '<img src="' + dataUrl + '" + class="clip">'

        CreateModal(dataUrl);

    });


}

// function createCheckboxMapGis(text, state, divId, func) {
//     let labelDivision = document.createElement('label');
//     labelDivision.classList.add('label-checkbox');
//     labelDivision
//     let inputDivision = document.createElement('input');
//     inputDivision.id = divId;
//     inputDivision.type = 'checkbox';
//     inputDivision.checked = state;
//     inputDivision.addEventListener('change', () => func());
//     labelDivision.appendChild(inputDivision);
//     var spanDivision = document.createElement('span');
//     spanDivision.innerText = text;
//     labelDivision.appendChild(spanDivision);
//     return labelDivision;
// }



/** Defines the Popup class. */

function click(e) {
    if (activo === 0)
        return;

    // if (activo == 1) {
    //     if (centro.length == 0) {
    //         centro.push([e.latLng.lat(), e.latLng.lng()]);
    //         return;
    //     }
    //     radio = L.latLng(centro[0][0], centro[0][1]).distanceTo(e.latlng);
    //     circulos.push([centro[0][0], centro[0][1], radio]);
    //     centro = [];
    //     CrearCirculo();
    // }

    if (activo === 2) {
        dataPoli[iPoly].push({ lat: e.latLng.lat(), lng: e.latLng.lng() });
        CrearLista();
    }

    // if (activo == 3) {
    //     distan.push([e.latlng.lat, e.latlng.lng]);
    //     CrearDistancia();
    // }

    if (activo === 8) {
        if (distance === null) {
            window.alert("Favor seleccione distancia.");
            return;
        }
        try {
            circle1.setMap(null);
            circle1 = null;
        } catch (e) { }
        circle1 = new google.maps.Circle({
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            map: mapGis,
            center: { lat: e.latLng.lat(), lng: e.latLng.lng() },
            radius: distance
        });
    }

    // if (activo >= 10 && activo <= 15) {
    //     var enviar = {
    //         e: e,
    //         activ : activo
    //     }
    //     custom = new CustomEntrie(enviar, CrearInstitucion);
    //     custom.Confirm();

    // }

}


function CrearLista() {
    try {
        for (let i = 0; i < polygon.length; i++) {
            polygon[i].setMap(null);
        }
    } catch (e) { }
    polygon = [];
    for (let i = 0; i < dataPoli.length; i++) {
        var polys = new google.maps.Polygon({
            paths: dataPoli[i],
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35
        });
        polygon.push(polys);
    }
    for (let i = 0; i < polygon.length; i++) {
        polygon[i].setMap(mapGis);
    }
    // document.getElementById("listPanel").innerHTML = "";
    // for (i = 0; i < dataPoli.length; i++) {
    //     for(j=0; j<dataPoli[i].length;j++)
    //     {
    //         var item = document.createElement("li");
    //         item.addEventListener("mouseenter", enterPoligon);
    //         item.addEventListener("mouseout", out);
    //         item.addEventListener("click", clickListPoly);
    //         item.dataset.pol = i;
    //         item.dataset.item = j;

    //         var lat = String(dataPoli[i][j][0]);
    //         var lng = String(dataPoli[i][j][1]);
    //         item.innerHTML = 'lat: ' + lat.substring(0, lat.indexOf(".") + 6) + ' - lng: ' + lng.substring(0, lng.indexOf(".") + 6);
    //         document.getElementById("listPanel").appendChild(item);
    //     }
    //     var item = document.createElement("li");
    //     document.getElementById("listPanel").appendChild(item);
    // }
}

export const InserBarrio = (object, id) => {
    for (let i = 0; i < polyBarrios.descriptions.length; i++) {
        let info = JSON.parse(polyBarrios.descriptions[i]);
        if (info[object] === id) {
            dataPoli[iPoly] = polyBarrios.polygons[i];
            MasPoly();
        }
    }
    CrearLista();
    var bounds = new google.maps.LatLngBounds();
    for (let j = 0; j < dataPoli.length; j++) {
        for (let i = 0; i < dataPoli[j].length; i++) {
            bounds.extend(dataPoli[j][i]);
        }
    }
    mapGis.fitBounds(bounds);
}

function InsertComuna(id) {
    for (let i = 0; i < polyComunas.descriptions.length; i++) {
        let info = JSON.parse(polyComunas.descriptions[i]);
        if (info.comuna_id === id) {
            dataPoli[iPoly] = polyComunas.polygons[i];

            MasPoly();
            CrearLista();
            break;
        }
    }
}


export const MasPoly = () => {
    iPoly++;
    dataPoli[iPoly] = [];
}

export const BorrarPoli = () => {
    if (window.confirm("¿Desea limpiar las figuras del mapa?"))
        eraseMap();
}

export const BorrarDato = () => {
    try {
        hideHeat();
        hideMarkers();

    } catch (error) {

    }

    dataMap = [];
    dataMapCircle = [];
}

export const DatosChecks = (value) => {
    eraseMap();
    checComunas = value.comuna;
    for (let i = 0; i < checComunas.length; i++) {
        InsertComuna(checComunas[i] + 1);
    }

}

export const SendData = (data) => {

    location = data;
    BorrarDato();
    SendPoli();
    SendCircle();
}



function eraseMap() {
    try {
        for (let i = 0; i < polygon.length; i++) {
            polygon[i].setMap(null);
        }

    } catch (e) { }
    try {
        circle1.setMap(null);
        circle1 = null;
    } catch (e) { }

    iPoly = 0;
    dataPoli = [[]];
    distance = null;
}


export const SendCircle = () => {
    if (circle1 !== null) {
        let center = circle1.getCenter();
        dataCircle(location, center);
    }
}

function dataCircle(datos, center) {
    dataMapCircle = [];
    for (let j = 0; j < datos.length; j++) {
        let betPoints = getDistance(new google.maps.LatLng(datos[j]), center);
        if (betPoints <= distance) {
            dataMapCircle.push(datos[j]);
        }
    }

    createMarkers(dataMapCircle);
}

export const SendPoli = () => {

    if (polygon.length === 0)
        return 1;


    // var method = "post"; // Set method to post by default if not specified.
    // var path = "/Datos/PuntosEnPol";
    // var cuantos = 0;

    for (let i = 0; i < polygon.length; i++) {
        DataMapa(location);
        createMarkers(dataMap);

    }

    return 0;
}

// function GetCorners(points) {
//     let top, left, rigth, buttom;
//     for (let i = 0; i < points.length; i++) {
//         if (i == 0) {
//             top = points[i].lat;
//             buttom = points[i].lat;
//             left = points[i].lng;
//             rigth = points[i].lng;
//         } else {
//             if (points[i].lat > top)
//                 top = points[i].lat;
//             if (points[i].lat < buttom)
//                 buttom = points[i].lat;
//             if (points[i].lng > rigth)
//                 rigth = points[i].lng;
//             if (points[i].lng < left)
//                 left = points[i].lng;
//         }
//     }
//     return [{ lat: top, lng: rigth }, { lat: buttom, lng: left }];
// }

function DataMapa(datos) {
    dataMap = [];
    for (let j = 0; j < datos.length; j++) {
        for (let k = 0; k < polygon.length; k++) {
            if (RayCasting(polygon[k].getPath(), datos[j]) === 1) {
                dataMap.push(datos[j]);
            }
        }
    }
}

function RayCasting(poli, punto) {
    if (typeof poli === 'undefined')
        return 0;
    var puntos = poli.j;
    var entra = 0;
    var i;
    for (i = 1; i < puntos.length; i++) {
        if (IsRigth(puntos[i - 1], puntos[i], punto) === 1) {
            entra++;
        }
    }
    if (IsRigth(puntos[i - 1], puntos[0], punto) === 1) {
        entra++;
    }
    if (entra > 0) {
        var si = entra % 2;
        if (si === 1)
            return 1;
    }
    return 0;
}

function IsRigth(p1, p2, com) {
    var m;
    try {
        m = (p2.lat() - p1.lat()) / (p2.lng() - p1.lng());
    } catch (e) { m = 0; }
    var b = p1.lat() - m * p1.lng();
    var p = m * com.lng + b;

    if (m < 0)// =>  \
    {
        if (p1.lat() >= p2.lat()) {
            if (p1.lat() >= com.lat && p2.lat() <= com.lat) {
                if (p <= com.lat) {
                    return 1;
                }
            }
        } else {
            if (p2.lat() >= com.lat && p1.lat() <= com.lat) {
                if (p <= com.lat) {
                    return 1;
                }
            }
        }
    } else   // => /
    {
        if (p2.lat() >= p1.lat()) {
            if (p2.lat() >= com.lat && p1.lat() <= com.lat) {
                if (p >= com.lat) {
                    return 1;
                }
            }
        } else {
            if (p1.lat() >= com.lat && p2.lat() <= com.lat) {
                if (p >= com.lat) {
                    return 1;
                }
            }
        }
    }
    return 0;
}

export const ToggleMarkerHeat = () => {
    if (stateHeat) {
        stateHeat = false;
        hideHeat();
        showMarkers()
    } else {
        stateHeat = true;
        hideMarkers();
        showHeat();
    }
}

function hideMarkers() {
    markersGis.map((value, i) => {
        value.setMap(null);
        return null;
    });
}

function showMarkers() {
    markersGis.map((value, i) => {
        value.setMap(mapGis);
        return null;
    });
}

function hideHeat() {
    heatmapGis.setMap(null);
}

function showHeat() {
    heatmapGis.setMap(mapGis);
}


/** Defines the Popup class. */
function definePopupClass() {

    PopupGis = function (position, content, tooltip) {
        this.position = position;
        console.log(tooltip);
        content.classList.add('popup-bubble-content');

        var pixelOffset = document.createElement('div');
        pixelOffset.classList.add('popup-bubble-anchor');

        var title = document.createElement('p');
        title.classList.add('popup-bundle-title');
        title.innerHTML = getIcon(tooltip.fen).split('green').join('#fff') + ' ' + tooltip.fen;
        var closeWindow = document.createElement('i');
        closeWindow.innerHTML = '<i class="popup-bundle-close material-icons">clear</i>';
        closeWindow.addEventListener('click', () => { try { popupOldGis.setMap(null) } catch (e) { } })
        title.appendChild(closeWindow);
        var texts = document.createElement('div');
        texts.classList.add('popup-bubble-text');
        var map = document.createElement('div');
        map.id = 'mapStreetView';
        map.classList.add('popup-bubble-map')

        texts.appendChild(insertTooltipData(tooltip.fecha));
        texts.appendChild(insertTooltipData(tooltip.gender));
        texts.appendChild(insertTooltipData(tooltip.jornada));
        texts.appendChild(insertTooltipData(tooltip.comuna));
        texts.appendChild(insertTooltipData(tooltip.barrio));
        content.appendChild(title);
        content.appendChild(texts);
        content.appendChild(map);


        pixelOffset.appendChild(content);

        this.anchor = document.createElement('div');
        this.anchor.classList.add('popup-tip-anchor');
        this.anchor.appendChild(pixelOffset);

        // Optionally stop clicks, etc., from bubbling up to the map.
        this.stopEventPropagation();
    };
    // NOTE: google.maps.OverlayView is only defined once the Maps API has
    // loaded. That is why Popup is defined inside initMap().
    PopupGis.prototype = Object.create(google.maps.OverlayView.prototype);

    /** Called when the popup is added to the map. */
    PopupGis.prototype.onAdd = function () {
        this.getPanes().floatPane.appendChild(this.anchor);
        // var panorama = new google.maps.StreetViewPanorama(
        //     document.getElementById('mapStreetView'), {
        //         position: this.position,
        //         pov: {
        //             heading: 270,
        //             pitch: 0
        //         },
        //         visible: true
        //     });
    };

    /** Called when the popup is removed from the map. */
    PopupGis.prototype.onRemove = function () {
        if (this.anchor.parentElement) {
            this.anchor.parentElement.removeChild(this.anchor);
            let div = document.createElement('div');
            div.id = 'content';
            document.body.appendChild(div);
        }
    };

    /** Called when the popup needs to draw itself. */
    PopupGis.prototype.draw = function () {
        var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
        // Hide the popup when it is far out of view.
        var display =
            Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
                'block' :
                'none';

        if (display === 'block') {
            this.anchor.style.left = divPosition.x + 'px';
            this.anchor.style.top = divPosition.y + 'px';
        }
        if (this.anchor.style.display !== display) {
            this.anchor.style.display = display;
        }
    };

    /** Stops clicks/drags from bubbling up to the map. */
    PopupGis.prototype.stopEventPropagation = function () {
        var anchor = this.anchor;
        anchor.style.cursor = 'auto';

        ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart',
            'pointerdown']
            .forEach(function (event) {
                anchor.addEventListener(event, function (e) {
                    e.stopPropagation();
                });
            });
    };
}

// function insertTootipData(propierty) {
//     if (propierty !== undefined && propierty !== null) {
//         var text = document.createElement('p');
//         text.innerText = propierty;
//         return text;
//     } else {
//         var span = document.createElement('span');
//         return span;
//     }
// }


function HttpServiceCom(src) {
    var xhttpIcon = new XMLHttpRequest();
    xhttpIcon.onreadystatechange = function () {
        if (this.readyState === 4) {
            if (this.status === 200) {
                var xmlString = this.response;
                var parser = new DOMParser();
                var comunas = parser.parseFromString(xmlString, "text/xml");
                polyComunas = CreatePolygonLater(comunas);
                docComunas = CreatePolygonMap(polyComunas, '#000', 'com');
                SetPolysInMap(docComunas);
            }
            else {
                console.log(this.responseText);
            }
        }
    };
    xhttpIcon.open("GET", src, true);
    // xhttpIcon.setRequestHeader('Content-Type', 'bolb');
    xhttpIcon.send();
}

function HttpServiceBar(src) {
    var xhttpIcon = new XMLHttpRequest();
    xhttpIcon.onreadystatechange = function () {
        if (this.readyState === 4) {
            if (this.status === 200) {
                var xmlString = this.response;
                var parser = new DOMParser();
                var barrios = parser.parseFromString(xmlString, "text/xml");
                polyBarrios = CreatePolygonLater(barrios);
                docBarrios = CreatePolygonMap(polyBarrios, '#000', 'bar');
                SetPolysInMap(docBarrios);
            }
            else {
                console.log(this.responseText);
            }
        }
    };
    xhttpIcon.open("GET", src, true);
    // xhttpIcon.setRequestHeader('Content-Type', 'bolb');
    xhttpIcon.send();
}

function CreatePolygonLater(doc) {
    let polygons = [];
    let descriptions = [];
    var places = doc.getElementsByTagName('Placemark');
    for (let i = 0; i < places.length; i++) {
        polygons.push(GetCordsFromPlacemark(places[i]));
        descriptions.push(GetDescFromPlacemark(places[i]));
    }
    return { polygons, descriptions };
}

function GetCordsFromPlacemark(place) {
    var coords = place.getElementsByTagName('coordinates');
    var coordsVec = coords[0].innerHTML.split(" ");
    var resp = [];
    for (let i = 0; i < coordsVec.length; i++) {
        let vec = coordsVec[i].split(',');
        resp.push({ lng: Number(vec[0]), lat: Number(vec[1]) });
    }
    return resp;
}

function GetDescFromPlacemark(place) {
    var desc = place.getElementsByTagName('description')[0].innerHTML;
    return desc;
}

function CreatePolygonMap(polys, color, tipo) {
    var polygons = [];
    for (let i = 0; i < polys.polygons.length; i++) {
        var poly = new google.maps.Polygon({
            paths: polys.polygons[i],
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: 1,
            fillColor: '#fff',
            fillOpacity: 0.35
        });
        google.maps.event.addListener(poly, 'click', function (event) {
            // let info = JSON.parse(polys.descriptions[i]);
            click(event);
        });
        polygons.push(poly);
    }
    return polygons;
}

function SetPolysInMap(polygon) {
    for (let i = 0; i < polygon.length; i++) {
        polygon[i].setMap(mapGis);
    }
}

// function DeletePolysInMap(polygon) {
//     for (let i = 0; i < polygon.length; i++) {
//         polygon[i].setMap(null);
//     }
// }



function getIconPath(fenomene) {
    var path = 'http://administrativo.eaconsultores.com.co/Content/files/icons2/';
    switch (fenomene) {
        case 'Violencia Intrafamiliar (VIF)': return path + 'sig-vif.svg';
        case 'SIC': return path + 'sig-sic.svg';
        case 'Rumba Segura': return path + 'sig-rs.svg';
        case 'Recuperacion Vehiculos': return path + 'sig-r.v.svg';
        case 'Recuperacion Motos': return path + 'sig-r.m.svg';
        case 'Parte Diario': return path + 'sig-homi.svg';
        case 'Lesiones Personales': return path + 'sig-l.p.svg';
        case 'Incautaciones Estupefacientes': return path + 'sig-i.e.svg';
        case 'Incautaciones Armas': return path + 'sig-i.a.svg';
        case 'Homicidios': return path + 'sig-homi.svg';
        case 'Delitos sexuales': return path + 'sig-ds.svg';
        case 'Comparendos': return path + 'sig-compa.svg';
        case 'Codigo Nacional Policia': return path + 'sig-cnp.svg';
        case 'Caracterizacion': return path + 'sig-homi.svg';
        case 'Capturas': return path + 'sig-homi.svg';
        case 'Aprovechamiento Espacio Publico': return path + 'sig-aep.svg';
        case 'Accidentalidad': return path + 'sig-acci.svg';
        case 'Hurto Vivienda': return path + 'sig-h.res.svg';
        case 'Hurto Vehiculo': return path + 'sig-h.v.svg';
        case 'Hurto Persona': return path + 'sig-h.p.svg';
        case 'Hurto Moto': return path + 'sig-h.m.svg';
        case 'Hurto Comercio': return path + 'sig-h.com.svg';
        case 'Hurto Celulares': return path + 'sig-h.cel.svg';
        default: return '';
    }
}

function getIcon(fenomene) {
    switch (fenomene) {
        case 'Homicidios': return ReactDOMServer.renderToString(Fenomenes.HOMICIDIOS('white'));
        case 'Lesiones Personales': return ReactDOMServer.renderToString(Fenomenes.LESIONES_PERSONALES('white'));
        case 'Extorsión': return ReactDOMServer.renderToString(Fenomenes.EXTORSION('white'));
        case 'Capturas': return ReactDOMServer.renderToString(Fenomenes.CAPTURAS('white'));
        case 'Recuperaciones Automotores': return ReactDOMServer.renderToString(Fenomenes.RECUPERACION_VEHICULOS('white'));
        case 'Recuperaciones Motocicletas': return ReactDOMServer.renderToString(Fenomenes.RECUPERACION_MOTOS('white'));
        case 'Incautaciones armas de fuego': return ReactDOMServer.renderToString(Fenomenes.INCAUTACIONES_ARMAS('white'));
        
        case 'Hurto Automotores': return ReactDOMServer.renderToString(Thiefts.HURTO_VEHICULO('white'));
        case 'Hurto Abigeato': return ReactDOMServer.renderToString(Thiefts.HURTO_ABIGETAO('white'));
        case 'Hurto a Residencias': return ReactDOMServer.renderToString(Thiefts.HURTO_VIVIENDA('white'));
        case 'Hurto Piratería Terrestre': return ReactDOMServer.renderToString(Thiefts.HURTO_PIRATERIA('white'));
        case 'Hurto a Personas': return ReactDOMServer.renderToString(Thiefts.HURTO_PERSONA('white'));
        case 'Hurto Motocicletas': return ReactDOMServer.renderToString(Thiefts.HURTO_MOTO('white'));
        case 'Hurto a Comercio': return ReactDOMServer.renderToString(Thiefts.HURTO_COMERCIO('white'));
        case 'Hurto a Bancos': return ReactDOMServer.renderToString(Thiefts.HURTO_BANCOS('white'));

        default: return '';
    }
}

function insertTooltipData(propierty) {
    if (propierty !== undefined && propierty !== null) {
        var text = document.createElement('p');
        text.innerText = propierty;
        return text;
    } else {
        var span = document.createElement('span');
        return span;
    }
}

var rad = function (x) {
    return x * Math.PI / 180;
};

var getDistance = function (p1, p2) {
    var R = 6378137; // Earth’s mean radius in meter
    var dLat = rad(p2.lat() - p1.lat());
    var dLong = rad(p2.lng() - p1.lng());
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(rad(p1.lat())) * Math.cos(rad(p2.lat())) *
        Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d; // returns the distance in meter
};

var location = [];


var styleRoad = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#bdbdbd"
            }
        ]
    },
    {
        "featureType": "poi",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "white-color"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dadada"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "transit",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#c9c9c9"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    }
];

var styleClean = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#bdbdbd"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "road",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "white-color"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dadada"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "transit",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#c9c9c9"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    }
];
